import React from 'react'

const UserDetailsModal = () => {
    return (
        <>
            <div className="modal fade" id="userDetailsModal" tabindex="-1" role="dialog" aria-labelledby="userDetailsModalLabel">
                <div className="modal-dialog modal-dialog-centered modal-xl" role="document">
                    <div className="modal-content">
                        <div className="modal-body p-4">
                            <div className="row">
                                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 my-auto">
                                    <div className="d-flex">
                                        <h6 className='mr-3'>User Name : <span>Aldrin</span></h6>
                                        <h6>User Type : <span>Employee</span></h6>
                                    </div>
                                </div>
                                <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6 col-sm-12 col-xs-12 my-auto">
                                    <div className="d-flex justify-content-end">
                                        <button type='button' className='btn cancel-btn' data-dismiss="modal">Cancel</button>
                                        <button type='button' className='btn save-btn' data-dismiss="modal">Save</button>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-3">
                                <div className="col-xxl-12 col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12">
                                    <div className="user-details-table">
                                        <table className="table table-striped table-borderless">
                                            <thead>
                                                <tr>
                                                    <th scope="col">
                                                        <div className="custom-control custom-checkbox custom-checkbox-blue">
                                                            <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                                                            <label className="custom-control-label pt-1" for="customCheck1"></label>
                                                        </div>
                                                    </th>
                                                    <th scope="col">Product Group</th>
                                                    <th scope="col" className="">Factory MP</th>
                                                    <th scope="col">Default MP</th>
                                                    <th scope="col">Minimum MP</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <div className="custom-control custom-checkbox custom-checkbox-blue">
                                                            <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                                                            <label className="custom-control-label pt-1" for="customCheck1"></label>
                                                        </div>
                                                    </td>
                                                    <td>CURTAIN FIRE DAMPER</td>
                                                    <td>0.4</td>
                                                    <td>0.6</td>
                                                    <td>0.6</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="custom-control custom-checkbox custom-checkbox-blue">
                                                            <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                                                            <label className="custom-control-label pt-1" for="customCheck1"></label>
                                                        </div>
                                                    </td>
                                                    <td>CURTAIN FIRE DAMPER</td>
                                                    <td>0.4</td>
                                                    <td>0.6</td>
                                                    <td>0.6</td>
                                                </tr>
                                                <tr>
                                                    <td>
                                                        <div className="custom-control custom-checkbox custom-checkbox-blue">
                                                            <input type="checkbox" className="custom-control-input custom-control-input-blue" id="customCheck1" />
                                                            <label className="custom-control-label pt-1" for="customCheck1"></label>
                                                        </div>
                                                    </td>
                                                    <td>CURTAIN FIRE DAMPER</td>
                                                    <td>0.4</td>
                                                    <td>0.6</td>
                                                    <td>0.6</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default UserDetailsModal